import { z } from 'zod';

export const AccountJSONSchema = z.object({
	id: z.uuidv4(),
	name: z.string(),
});

export type IAccountJSON = z.infer<typeof AccountJSONSchema>;
